import { DataGridProps } from '@mui/x-data-grid';
import { DATAGRID_DEFAULT_PAGE_SIZE, DATAGRID_PAGE_SIZE_OPTIONS } from 'v2/constants';
import { dataGridIdSlots } from './dataGridIdSlots';

type Params = {
  rowCount: number;
  loading?: boolean;
};

type OverviewDataGridProps = Pick<
  DataGridProps,
  | 'autoHeight'
  | 'hideFooter'
  | 'pageSizeOptions'
  | 'loading'
  | 'disableRowSelectionOnClick'
  | 'disableColumnMenu'
  | 'slots'
  | 'slotProps'
  | 'initialState'
>;

export const getOverviewDataGridProps = ({ rowCount, loading = false }: Params): OverviewDataGridProps => ({
  autoHeight: true,
  hideFooter: rowCount <= DATAGRID_DEFAULT_PAGE_SIZE,
  pageSizeOptions: DATAGRID_PAGE_SIZE_OPTIONS,
  loading,
  disableRowSelectionOnClick: true,
  disableColumnMenu: true,
  slots: dataGridIdSlots,
  slotProps: {
    loadingOverlay: {
      variant: 'skeleton',
      noRowsVariant: 'skeleton'
    }
  },
  initialState: {
    pagination: {
      paginationModel: { pageSize: DATAGRID_DEFAULT_PAGE_SIZE }
    }
  }
});
